import React, { useState } from 'react';
import loadable from "@loadable/component";
import pMinDelay from "p-min-delay";
import { Tab, Nav, Tabs } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { AddUpdate } from '../../../../ApiMethods/ApiMethods';




const ChartBarApex = loadable(() =>
	// pMinDelay(import("./ChartBarApex"), 1000)
	pMinDelay(import("./ChartBarApex"),)
);
const ChartBarApex2 = loadable(() =>
	pMinDelay(import("./ChartBarApex2"),)
);
const ChartBarApex3 = loadable(() =>
	pMinDelay(import("./ChartBarApex3"),)
);
const ChatChart = loadable(() =>
	pMinDelay(import("./ChatChart"),
	));
const GemstoneRevenueChart = loadable(() =>
	pMinDelay(import("./GemstoneRevenueChart"),
	));
const PoojaRevenueChart = loadable(() =>
	pMinDelay(import("./PoojaRevenueChart"),
	));
const CallRevenueChart = loadable(() =>
	pMinDelay(import("./CallRevenueChart"),
	));
const UserRegPeakHourChart = loadable(() =>
	pMinDelay(import("./UserRegPeakHourChart"),
));
const UserRegAgeChart = loadable(() =>
	pMinDelay(import("./UserRegAgeChart"),
));

const ReservationStats = () => {
		const dispatch = useDispatch()
	const [filterType, setFilterType] = useState("daily");
	const [filterType1, setFilterType1] = useState("daily");
	const [filterType2, setFilterType2] = useState("daily")
	const [chattype, setChatType] = useState("daily")
	const [gemstoneRevenueType, setGemstoneRevenueType] = useState("daily")
	const [poojaRevenueType, setPoojaRevenueType] = useState("daily")
	const [callRevenueType, setCallRevenueType] = useState("daily")
	const [userRegType, setUserRegType] = useState("daily")
	const [userTotalRegistrations, setUserTotalRegistrations] = useState(0)
	const [userAgeType, setUserAgeType] = useState("daily")
	const [userAgeTotalRegistrations, setUserAgeTotalRegistrations] = useState(0)


const calldata = useSelector((state) => state.feedBackReducer.calldata || []);
const chatdata = useSelector((state) => state.feedBackReducer.TotalChart || []);
const totaluser = useSelector((state) => state.feedBackReducer.UserStatus||[]);
const Totalastrologer = useSelector((state) => state.feedBackReducer.TotalAstrologer || []);
const Totalgemstonerevenue = useSelector((state) => state.feedBackReducer.GemstoneRevenues||[]);
const Totalpoojarevenue = useSelector((state) => state.feedBackReducer.PoojaRevenues||[]);
const Callrevenuedata = useSelector((state) => state.feedBackReducer.CallRevenues || []);

const totalCall = calldata.reduce((sum, item) => sum + (item.Count || 0), 0);
const TotalChat = chatdata.reduce((sum, item) => sum + (item.Count || 0), 0);
const Totaluser = totaluser.reduce((sum, item) => sum + (item.Count || 0), 0);
const totalastrologer = Totalastrologer.reduce((sum, item) => sum + (item.Count || 0), 0);
const totalgemstonerevenue = Totalgemstonerevenue.reduce((sum, item) => sum + (item.Count || 0), 0);
const totalpoojarevenue = Totalpoojarevenue.reduce((sum, item) => sum + (item.Count || 0), 0);
const callrevenuedata = Callrevenuedata.reduce((sum, item) => sum + (item.Count || 0), 0);

const getDateRangeForUser = (type) => {
		const today = new Date();
		if (type === "daily") {
			const from = today.toISOString().split("T")[0];
			return { CreatedFrom: from, CreatedTo: from };
		}
		if (type === "weekly") {
			const dayOfWeek = today.getDay();
			const diffToMonday = dayOfWeek === 0 ? -6 : 1 - dayOfWeek;
			const startOfWeek = new Date(today);
			startOfWeek.setDate(today.getDate() + diffToMonday);
			const endOfWeek = new Date(startOfWeek);
			endOfWeek.setDate(startOfWeek.getDate() + 6);
			return {
				CreatedFrom: startOfWeek.toISOString().split("T")[0],
				CreatedTo: endOfWeek.toISOString().split("T")[0],
			};
		}
		const year = today.getFullYear();
		const from = new Date(year, 0, 1).toISOString().split("T")[0];
		const to = new Date(year, 11, 31).toISOString().split("T")[0];
		return { CreatedFrom: from, CreatedTo: to };
	};

React.useEffect(() => {
	let mounted = true;
	const fetchTotals = async () => {
		try {
			const postData = getDateRangeForUser(userRegType);
			const res = await AddUpdate("User/Users_Peakhour", postData);
			const resdata = JSON.parse(res?.data?.data || "{}");
			const rows = resdata?.Table || [];
			const total = rows.reduce((s, r) => s + Number(r.TotalRegistrations || 0), 0);
			if (mounted) setUserTotalRegistrations(total);
		} catch (err) {
			console.error(err);
		}
	};
	fetchTotals();
	return () => { mounted = false };
}, [userRegType]);

React.useEffect(() => {
  let mounted = true;
  const fetchTotalsAge = async () => {
    try {
      const postData = getDateRangeForUser(userAgeType);
      const res = await AddUpdate("User/Users_PeakAge", postData);
      const resdata = JSON.parse(res?.data?.data || "{}");
      const rows = resdata?.Table || [];
      const total = rows.reduce((s, r) => s + Number(r.TotalRegistrations || 0), 0);
      if (mounted) setUserAgeTotalRegistrations(total);
    } catch (err) {
      console.error(err);
    }
  };
  fetchTotalsAge();
  return () => { mounted = false };
}, [userAgeType]);


	return (
		<>
			<div className="row">
				{/* Total Call Tab.Container */}
				<div className="col-lg-6 col-md-12 mb-4">
					<Tab.Container defaultActiveKey="Monthly">
						<div className="card">
							<div className="card-header border-0 flex-wrap">
								<h4 className="fs-20">Total Calls/ Total Chats</h4>

							</div>
							<div className="card-body pb-0">
								<div className="d-flex flex-wrap">
									<span className="me-sm-4 me-0 font-w500">
										<svg className="me-1" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
											<rect width="13" height="13" fill="#135846" />
										</svg>
										Total Chats
									</span>
									<span className="fs-16 font-w600 me-4"style={{color:"black"}}>{totalCall}</span>
									{/* <small className="text-success fs-12 font-w400">+0.4%</small> */}
									<span className="me-sm-4 ms-0 font-w500">
										<svg className="me-1" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
											<rect width="13" height="13" fill="#E23428" />
										</svg>
										Total Calls
									</span>
									<span className="fs-16 font-w600 me-4"style={{color:"black"}}>{TotalChat}</span>
								</div>

								<Tab.Container defaultActiveKey="Daily">
									<Tabs onSelect={(key) => setFilterType(key.toLowerCase())}>
										<Tab eventKey="Daily" title={<span className="fs-4">Daily</span>}>
											<div id="chartBar">

												{filterType === "daily" && <ChartBarApex2 filterType={filterType} />}
											</div>
										</Tab>
										<Tab eventKey="Weekly" title={<span className="fs-4">Weekly</span>}>
											<div id="chartBar1">

												{filterType === "weekly" && <ChartBarApex2 filterType={filterType} />}
											</div>
										</Tab>
										<Tab eventKey="Monthly" title={<span className="fs-4">Monthly</span>}>
											<div id="chartBar2">

												{filterType === "monthly" && <ChartBarApex2 filterType={filterType} />}
											</div>
										</Tab>
									</Tabs>
								</Tab.Container>
							</div>
						</div>
					</Tab.Container>
				</div>

				{/* Total Users Tab.Container */}
				<div className="col-lg-6 col-md-12 mb-4">
					<Tab.Container defaultActiveKey="Monthly">
						<div className="card">
							<div className="card-header border-0 flex-wrap">
								<h4 className="fs-20">Total Users/ Total Astrologers </h4>

							</div>
							<div className="card-body pb-0">
								<div className="d-flex flex-wrap">
									<span className="me-sm-4 me-0 font-w500">
										<svg className="me-1" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
											<rect width="13" height="13" fill="#135846" />
										</svg>
										Total Users
									</span>
									<span className="fs-16 font-w600 me-4"style={{color:"black"}}>{Totaluser} </span>

									{/* <small className="text-success fs-12 font-w400">+0.4%</small> */}
									<span className="me-sm-4 ms-0 font-w500">
										<svg className="me-1" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
											<rect width="13" height="13" fill="#E23428" />
										</svg>
										Total Astrologers
									</span>
									<span className="fs-16 font-w600" style={{color:"black"}}>{totalastrologer}</span>
								</div>


								<Tab.Container defaultActiveKey="Daily">
									<Tabs onSelect={(key) => setFilterType1(key.toLowerCase())}>
										<Tab eventKey="Daily" title={<span className="fs-4">Daily</span>}>
											<div id="chartBar">

												{filterType1 === "daily" && <ChartBarApex3 filterType={filterType1} />}
											</div>
										</Tab>
										<Tab eventKey="Weekly" title={<span className="fs-4">Weekly</span>}>
											<div id="chartBar1">

												{filterType1 === "weekly" && <ChartBarApex3 filterType={filterType1} />}
											</div>
										</Tab>
										<Tab eventKey="Monthly" title={<span className="fs-4">Monthly</span>}>
											<div id="chartBar2">

												{filterType1 === "monthly" && <ChartBarApex3 filterType={filterType1} />}
											</div>
										</Tab>
									</Tabs>
								</Tab.Container>


							</div>
						</div>
					</Tab.Container>
				</div>

				
				<div className="col-lg-6 col-md-12 mb-4">
					<Tab.Container defaultActiveKey="Monthly">
						<div className="card">
							<div className="card-header border-0 flex-wrap">
								<h4 className="fs-20">GemStone Revenue / Pooja Revenue</h4>

							</div>
							<div className="card-body pb-0">
								<div className="d-flex flex-wrap">
									<span className="me-sm-4 me-0 font-w500">
										<svg className="me-1" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
											<rect width="13" height="13" fill="#135846" />
										</svg>
										GemStone Revenue
									</span>
									<span className="fs-16 font-w600 me-4"style={{color:"black"}}>{totalgemstonerevenue}</span>
									{/* <small className="text-success fs-12 font-w400">+0.4%</small> */}
									<span className="me-sm-4 ms-0 font-w500">
										<svg className="me-1" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
											<rect width="13" height="13" fill="#E23428" />
										</svg>
										Pooja Revenue
									</span>
									<span className="fs-16 font-w600"style={{color:"black"}}>{totalpoojarevenue}</span>
								</div>

								<Tab.Container defaultActiveKey="Daily">
									<Tabs onSelect={(key) => setGemstoneRevenueType(key.toLowerCase())}>
										<Tab eventKey="Daily" title={<span className="fs-4">Daily</span>}>
											<div id="chartBar">

												{gemstoneRevenueType === "daily" && <GemstoneRevenueChart filterType={gemstoneRevenueType} />}
											</div>
										</Tab>
										<Tab eventKey="Weekly" title={<span className="fs-4">Weekly</span>}>
											<div id="chartBar1">

												{gemstoneRevenueType === "weekly" && <GemstoneRevenueChart filterType={gemstoneRevenueType} />}
											</div>
										</Tab>
										<Tab eventKey="Monthly" title={<span className="fs-4">Monthly</span>}>
											<div id="chartBar2">

												{gemstoneRevenueType === "monthly" && <GemstoneRevenueChart filterType={gemstoneRevenueType} />}
											</div>
										</Tab>
									</Tabs>
								</Tab.Container>

							</div>
						</div>
					</Tab.Container>
				</div>


				

				{/* call Revenue Tab.Container */}
				<div className="col-lg-6 col-md-12 mb-4">
					<Tab.Container defaultActiveKey="Monthly">
						<div className="card">
							<div className="card-header border-0 flex-wrap">
								<h4 className="fs-20">Call Revenue</h4>

							</div>
							<div className="card-body pb-0">
								<div className="d-flex flex-wrap">
									<span className="me-sm-4 me-0 font-w500">
										<svg className="me-1" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
											<rect width="13" height="13" fill="#135846" />
										</svg>
										Call Revenue
									</span>
									<span className="fs-16 font-w600 me-4" style={{color:"black"}}>{callrevenuedata}</span>
									
								</div>

								<Tab.Container defaultActiveKey="Daily">
									<Tabs onSelect={(key) => setCallRevenueType(key.toLowerCase())}>
										<Tab eventKey="Daily" title={<span className="fs-4">Daily</span>}>
											<div id="chartBar">

												{callRevenueType === "daily" && <CallRevenueChart filterType={callRevenueType} />}
											</div>
										</Tab>
										<Tab eventKey="Weekly" title={<span className="fs-4">Weekly</span>}>
											<div id="chartBar1">

												{callRevenueType === "weekly" && <CallRevenueChart filterType={callRevenueType} />}
											</div>
										</Tab>
										<Tab eventKey="Monthly" title={<span className="fs-4">Monthly</span>}>
											<div id="chartBar2">

												{callRevenueType === "monthly" && <CallRevenueChart filterType={callRevenueType} />}
											</div>
										</Tab>
									</Tabs>
								</Tab.Container>

							</div>
						</div>
					</Tab.Container>
				</div>





		<div className="col-lg-6 col-md-12 mb-4">
			<Tab.Container defaultActiveKey="Monthly">
				<div className="card">
					<div className="card-header border-0 flex-wrap">
						<h4 className="fs-20">User Registration Hours</h4>

					</div>
					<div className="card-body pb-0">
						<div className="d-flex flex-wrap">
							<span className="me-sm-4 me-0 font-w500">
								<svg className="me-1" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
									<rect width="13" height="13" fill="#135846" />
								</svg>
								Total Registrations
							</span>
							<span className="fs-16 font-w600 me-4" style={{color:"black"}}>{userTotalRegistrations}</span>
						</div>

						<Tab.Container defaultActiveKey="Daily">
							<Tabs onSelect={(key) => setUserRegType(key.toLowerCase())}>
								<Tab eventKey="Daily" title={<span className="fs-4">Daily</span>}>
									<div id="chartBar">

										{userRegType === "daily" && <UserRegPeakHourChart filterType={userRegType} />}
									</div>
								</Tab>
								<Tab eventKey="Weekly" title={<span className="fs-4">Weekly</span>}>
									<div id="chartBar1">

										{userRegType === "weekly" && <UserRegPeakHourChart filterType={userRegType} />}
									</div>
								</Tab>
								<Tab eventKey="Monthly" title={<span className="fs-4">Monthly</span>}>
									<div id="chartBar2">

										{userRegType === "monthly" && <UserRegPeakHourChart filterType={userRegType} />}
									</div>
								</Tab>
							</Tabs>
						</Tab.Container>

					</div>
				</div>
			</Tab.Container>
		</div>





	<div className="col-lg-6 col-md-12 mb-4">
		<Tab.Container defaultActiveKey="Monthly">
			<div className="card">
				<div className="card-header border-0 flex-wrap">
					<h4 className="fs-20">User Registration Age</h4>

				</div>
				<div className="card-body pb-0">
					<div className="d-flex flex-wrap">
						<span className="me-sm-4 me-0 font-w500">
							<svg className="me-1" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
								<rect width="13" height="13" fill="#135846" />
							</svg>
							Total Registrations
						</span>
						<span className="fs-16 font-w600 me-4" style={{color:"black"}}>{userAgeTotalRegistrations}</span>
					</div>

					<Tab.Container defaultActiveKey="Daily">
						<Tabs onSelect={(key) => setUserAgeType(key.toLowerCase())}>
							<Tab eventKey="Daily" title={<span className="fs-4">Daily</span>}>
								<div id="chartBar">

									{userAgeType === "daily" && <UserRegAgeChart filterType={userAgeType} />}
								</div>
							</Tab>
							<Tab eventKey="Weekly" title={<span className="fs-4">Weekly</span>}>
								<div id="chartBar1">

									{userAgeType === "weekly" && <UserRegAgeChart filterType={userAgeType} />}
									</div>
							</Tab>
							<Tab eventKey="Monthly" title={<span className="fs-4">Monthly</span>}>
								<div id="chartBar2">

									{userAgeType === "monthly" && <UserRegAgeChart filterType={userAgeType} />}
									</div>
							</Tab>
						</Tabs>
					</Tab.Container>

				</div>
			</div>
		</Tab.Container>
	</div>








			</div>

		</>
	)
}
export default ReservationStats;